// Lissage du planning : plafonds de séances par jour (paliers), collisions de J0 entre sous-parties.
// --- FONCTION DE PROTECTION GLOBALE DES SOUS-PARTIES ---
window.actions.fixJ0Collisions = function(tasksArray) {
    var tasks = [].concat(tasksArray);
    var maxIter = 1000;
    if (tasks.length === 0) return tasks;

    var currDateStr = tasks.reduce(function(min, t) { return t.date < min ? t.date : min; }, window.toYYYYMMDD(new Date()));
    var currDateObj = window.parseDateLocal(currDateStr);

    while(maxIter > 0) {
        var cStr = window.toYYYYMMDD(currDateObj);
        var j0sToday = tasks.filter(function(t){ return t.date === cStr && t.status === 'pending' && t.type === 'J0' && !t.isDouble; });
        
        var baseMap = {};
        j0sToday.forEach(function(t) {
            var bId = t.baseItemId || t.itemId;
            if(!baseMap[bId]) baseMap[bId] = [];
            baseMap[bId].push(t);
        });

        var toShiftIds = [];
        Object.keys(baseMap).forEach(function(bId) {
            var grp = baseMap[bId];
            if (grp.length > 1) {
                grp.sort(function(a,b) { return a.itemId.localeCompare(b.itemId); });
                for (var i = 1; i < grp.length; i++) {
                    toShiftIds.push(grp[i].itemId);
                }
            }
        });

        if (toShiftIds.length > 0) {
            tasks = tasks.map(function(t) {
                if (toShiftIds.includes(t.itemId) && t.date.localeCompare(cStr) >= 0 && t.status === 'pending') {
                    var dd = window.parseDateLocal(t.date);
                    dd.setDate(dd.getDate() + 1);
                    return Object.assign({}, t, { date: window.toYYYYMMDD(dd) });
                }
                return t;
            });
        }

        currDateObj.setDate(currDateObj.getDate() + 1);
        var maxDate = tasks.reduce(function(max, t){ return (t.status === 'pending' && t.date > max) ? t.date : max; }, "");
        if (window.toYYYYMMDD(currDateObj) > maxDate) break;
        maxIter--;
    }
    return tasks;
};

// --- LISSAGE INTELLIGENT ---
// Paliers du lissage : « N par jour jusqu'au … », puis un autre N jusqu'à une autre date, et un dernier « ensuite »
// (sans date) pour la suite. Un seul palier sans date = l'ancien lissage à limite unique.
window.lissagePaliersNormalises = function(paliers) {
    var out = (paliers || []).map(function(p) { return { jusquau: /^\d{4}-\d{2}-\d{2}$/.test(p.jusquau || '') ? p.jusquau : '', limite: Math.max(0, parseInt(p.limite, 10) || 0), limiteJ0: Math.max(0, parseInt(p.limiteJ0, 10) || 0), limiteRev: Math.max(0, parseInt(p.limiteRev, 10) || 0) }; })
        .filter(function(p) { return p.limite >= 1 || p.limiteJ0 >= 1 || p.limiteRev >= 1; });
    // datés d'abord, dans l'ordre ; le palier sans date (« ensuite ») ferme la liste
    out.sort(function(a, b) { if (!a.jusquau !== !b.jusquau) return a.jusquau ? -1 : 1; return a.jusquau.localeCompare(b.jusquau); });
    return out;
};
// Limite qui s'applique un jour donné : le premier palier dont la date n'est pas dépassée ; sinon « ensuite » ;
// sinon le dernier palier daté (on ne lisse pas à l'infini au-delà de ce que l'utilisateur a réglé).
window.lissagePalierLe = function(paliers, dateStr) {
    for (var i = 0; i < paliers.length; i++) { if (!paliers[i].jusquau || dateStr <= paliers[i].jusquau) return paliers[i]; }
    return paliers.length ? paliers[paliers.length - 1] : null;
};
window.lissageLimiteLe = function(paliers, dateStr) {
    var p = window.lissagePalierLe(paliers, dateStr);
    return p ? (p.limite > 0 ? p.limite : Infinity) : Infinity;
};

window.lisserTaches = function(tasks, paliers, priority, dateDebutStr, pas) {
    pas = pas === 2 ? 2 : 1; // 2 : on décale de deux jours, pour garder la parité des jours (plannings pairs / impairs)
    var maxIterations = 2000;
    var currDateObj = window.parseDateLocal(dateDebutStr);
    
    while(maxIterations > 0) {
        var currDateStr = window.toYYYYMMDD(currDateObj);
        var tasksOnDate = tasks.filter(function(t){ return t.date === currDateStr && t.status === 'pending'; });
        var limiteJour = window.lissageLimiteLe(paliers, currDateStr);
        // Plafonds par catégorie (ordonnanceur) : limiteJ0 et limiteRev portés par le palier, en plus du total.
        var palierDuJour = window.lissagePalierLe(paliers, currDateStr) || {};
        var limJ0 = palierDuJour.limiteJ0 > 0 ? palierDuJour.limiteJ0 : Infinity, limRev = palierDuJour.limiteRev > 0 ? palierDuJour.limiteRev : Infinity;
        var nJ0 = tasksOnDate.filter(function(t) { return t.type === 'J0'; }).length, nRev = tasksOnDate.length - nJ0;
        
        if(tasksOnDate.length > limiteJour || nJ0 > limJ0 || nRev > limRev) {
            tasksOnDate.sort(function(a, b) {
                // les items d'un partiel à venir restent en place : ils ne font partie de l'excédent qu'en dernier recours
                var aEx = window.examForTask(a, currDateStr), bEx = window.examForTask(b, currDateStr);
                if (!!aEx !== !!bEx) return aEx ? -1 : 1;
                if (aEx && bEx && aEx.date !== bEx.date) return aEx.date.localeCompare(bEx.date);
                if (priority === 'new') {
                    var aJ0 = a.type === 'J0' ? 0 : 1;
                    var bJ0 = b.type === 'J0' ? 0 : 1;
                    if (aJ0 !== bJ0) return aJ0 - bJ0;
                } else if (priority === 'review') {
                    var aRev = a.type !== 'J0' ? 0 : 1;
                    var bRev = b.type !== 'J0' ? 0 : 1;
                    if (aRev !== bRev) return aRev - bRev;
                } else if (priority === 'score') {
                    if (a.score !== b.score) return b.score - a.score;
                }
                return a.id.localeCompare(b.id);
            });

            var excess = tasksOnDate.slice(limiteJour);
            // au-delà du plafond J0 ou du plafond révisions : les derniers de leur catégorie (dans l'ordre de priorité)
            var vusJ0 = 0, vusRev = 0;
            tasksOnDate.forEach(function(t) {
                if (t.type === 'J0') { vusJ0++; if (vusJ0 > limJ0 && excess.indexOf(t) < 0) excess.push(t); }
                else { vusRev++; if (vusRev > limRev && excess.indexOf(t) < 0) excess.push(t); }
            });
            var mapRefs = {};
            excess.forEach(function(tk) {
                if(!mapRefs[tk.itemId]) mapRefs[tk.itemId] = tk;
            });

            Object.values(mapRefs).forEach(function(ref) {
                tasks = tasks.map(function(t) {
                    if(t.itemId === ref.itemId && t.date.localeCompare(currDateStr) >= 0 && t.status === 'pending') {
                        var dd = window.parseDateLocal(t.date);
                        dd.setDate(dd.getDate() + pas);
                        return Object.assign({}, t, { date: window.toYYYYMMDD(dd) });
                    }
                    return t;
                });
            });
        }

        currDateObj.setDate(currDateObj.getDate() + 1);
        var maxDate = tasks.reduce(function(max, t){ return (t.status === 'pending' && t.date > max) ? t.date : max; }, "");
        if (window.toYYYYMMDD(currDateObj) > maxDate) break;
        maxIterations--;
    }

    return tasks;
};
// limit : un nombre (limite unique) ou une liste de paliers [{ jusquau, limite }] ; la limite du jour dépend du palier.

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const lissagePaliersNormalises = window.lissagePaliersNormalises;
export const lissagePalierLe = window.lissagePalierLe;
export const lissageLimiteLe = window.lissageLimiteLe;
export const lisserTaches = window.lisserTaches;
